import { listingsApiV1 } from '@app/services'

import { FetchListingsTotalResponse } from './types'

export const fetchPublishedListingsTotal = async (): Promise<number> => {
  try {
    const { data } = await listingsApiV1.get<FetchListingsTotalResponse>(
      'listings',
      {
        params: {
          'query.mode': 'OnlyTotal',
          'query.filters.state': 'Published',
        },
      }
    )

    return data.total
  } catch (error) {
    console.error('Failed to fetch published listings total', error)
    return 0
  }
}
